// FEATURE-34 — Launcher-side theme tokens.
//
// The launcher paints the floating button BEFORE the iframe loads, so it
// can't read the panel's CSS variables. Instead we duplicate a tiny subset
// of the design tokens (just what the button surface needs) so the button
// is themed from first paint. Values stay in sync with the panel's
// `src/theme/tokens.ts` by convention — keep the worldtrans entry pointing
// at the same brand color as FEATURE-36 introduces.
//
// Net cost in the launcher bundle: ~50 bytes per theme (well inside the
// 10 kB ceiling).

import type { ThemeName } from '@ba/protocol';

export interface LauncherButtonTokens {
  /** Background of the floating button (any valid CSS color). */
  background: string;
  /** Foreground used for the icon / label on the button. */
  foreground: string;
  /** Border-radius — keep this in sync with the panel's `radius.full`. */
  radius: string;
  /** Drop shadow when the button is at rest. */
  shadow: string;
}

export const LAUNCHER_TOKENS: Record<ThemeName, LauncherButtonTokens> = {
  default: {
    background: 'rgb(11 92 173)',
    foreground: 'rgb(255 255 255)',
    radius: '9999px',
    shadow: '0 10px 30px rgb(11 92 173 / 0.35)',
  },
  // FEATURE-36 — orange brand + white foreground. Matches the live
  // worldtrans.vn CTA color (#F5A623). Verified against the site
  // screenshot — search button, login CTA, active tabs all use this
  // saturated orange.
  worldtrans: {
    background: 'rgb(245 166 35)',
    foreground: 'rgb(255 255 255)',
    radius: '9999px',
    shadow: '0 10px 30px rgb(245 166 35 / 0.40)',
  },
};
